import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  TextField,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import API from "../../services";
import { USER_API } from "../../services";
import { BetList } from "../../models/BetList";
import list from "../../assets/images/list-view.svg";
import "./BetList.scss";
import moment from "moment";
import { RootState } from "../../models/RootState";
import { connect } from "react-redux";
import { DatePicker, DesktopDatePicker, LocalizationProvider } from "@mui/lab";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { calendarFormat } from "moment";

type StoreProps = {
  selectedProviderId: string;
};

const BetListPage: React.FC<StoreProps> = (props) => {
  const { selectedProviderId } = props;
  const [betList, setBetList] = useState<BetList[]>([]);
  const [filteredBetList, setFilteredBetList] = useState<BetList[]>(betList);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [fromDate, setFromDate] = useState<number>(
    moment().subtract(7, "days").startOf("day").valueOf()
  );
  const [toDate, setToDate] = useState<number>(moment().endOf("day").valueOf());
  const [selectedSport, setSelectedSport] = useState<string>("");
  const [selectedStatus, setSelectedStatus] = useState<string>("");
  const [sports, setSports] = useState([{ sportName: "All" }]);
  const [betStatus, setBetStatus] = useState(["ALL"]);
  const [dateValidationFail, setDateValidationFail] = useState<boolean>(false);

  useEffect(() => {
    fetchSportsByProvider();
  }, []);

  useEffect(() => {
    betList?.map((bet) => {
      setBetStatus((prevState) => {
        return prevState?.includes(bet.betStatus)
          ? [...prevState]
          : [...prevState, bet.betStatus];
      });
    });
  }, [betList]);

  useEffect(() => {
    getBetList();
  }, []);

  const getBetList = async () => {
    const res: any = await USER_API.post("/get-all-bets", {
      token: sessionStorage.getItem("psAuthToken"),
    });
    if (res.data.status === "RS_OK") {
      if (res?.data?.allBets) {
        let data = res?.data?.allBets;
        data.sort((a, b) => {
          return b.requestTime - a.requestTime;
        });
        setBetList(data);
      }
    } else {
      console.log("error");
    }
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const fetchSportsByProvider = async () => {
    try {
      const response: any = await API.post("/getsports", {
        operatorId: sessionStorage.getItem("psOperatorId"),
        providerId: sessionStorage.getItem("psProviderId"),
        token: sessionStorage.getItem("psAuthToken"),
      });
      if (response.data.status === "RS_OK") {
        const spList = response.data.sports.sort((a, b) => {
          let x = a.sportName.toLowerCase();
          let y = b.sportName.toLowerCase();
          if (x < y) {
            return -1;
          }
          if (x > y) {
            return 1;
          }
          return 0;
        });
        setSports((prevState) => {
          return [...prevState, ...spList];
        });
      } else {
      }
    } catch (err) {}
  };

  useEffect(() => {
    let filteredBets = betList.filter((bet) => {
      if (!fromDate || fromDate <= Number(bet.requestTime)) {
        if (!toDate || Number(bet.requestTime) <= toDate) {
          if (
            !selectedSport ||
            selectedSport === bet.sportName ||
            (selectedSport.toLowerCase() === "soccer" &&
              bet.sportName.toLowerCase() === "football")
          ) {
            if (!selectedStatus || selectedStatus === bet.betStatus) {
              return bet;
            }
          }
        }
      }
    });
    setFilteredBetList(filteredBets);
  }, [fromDate, toDate, selectedSport, selectedStatus, betList]);

  const onFromDateChange = (value) => {
    if (value && value.isValid()) {
      if (toDate <= moment(value.valueOf()).startOf("day").valueOf()) {
        setDateValidationFail(true);
        setToDate(moment().endOf("day").valueOf());
        setFromDate(moment().subtract(7, "days").startOf("day").valueOf());
        setTimeout(() => {
          setDateValidationFail(false);
        }, 3000);
      } else {
        setFromDate((prevState) => {
          return moment(value.valueOf()).startOf("day").valueOf();
        });
      }
    }
  };

  const onToDateChange = (value) => {
    if (value && value.isValid()) {
      if (fromDate >= moment(value.valueOf()).endOf("day").valueOf()) {
        setDateValidationFail(true);
        setToDate(moment().endOf("day").valueOf());
        setFromDate(moment().subtract(7, "days").startOf("day").valueOf());
        setTimeout(() => {
          setDateValidationFail(false);
        }, 3000);
      } else {
        setToDate((prevState) => {
          return moment(value.valueOf()).endOf("day").valueOf();
        });
      }
    }
  };
  const handleSportChange = (value) => {
    if (value.toLowerCase() === "all") {
      setSelectedSport("");
    } else {
      setSelectedSport(value);
    }
  };
  const handleStatusChange = (value) => {
    if (value.toLowerCase() === "all") {
      setSelectedStatus("");
    } else {
      setSelectedStatus(value);
    }
  };

  console.log("from Date", fromDate, "to Date", toDate, "Bet List", betList);

  return (
    <div className="bet-list-ctn">
      <div className="header-ctn">
        <div className="title">
          {/* <img className="sport-img" alt="list" src={list} /> */}
          Bet List
        </div>
      </div>
      <div className="filter-section">
        <div className="filter-items">
          <div className="filter-item">
            <form style={{ marginTop: "1rem" }}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DesktopDatePicker
                  className="input-date"
                  label="From Date"
                  value={fromDate}
                  onChange={(e) => {
                    onFromDateChange(e);
                  }}
                  renderInput={(params) => (
                    <TextField className="" {...params} />
                  )}
                />
              </LocalizationProvider>
            </form>
          </div>
          <div className="filter-item">
            <form style={{ marginTop: "1rem" }}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DesktopDatePicker
                  className="input-date"
                  label="To Date"
                  value={toDate}
                  minDate={moment("2017-01-01")}
                  onChange={(e) => onToDateChange(e)}
                  renderInput={(params) => (
                    <TextField className="" {...params} />
                  )}
                />
              </LocalizationProvider>
            </form>
          </div>
          <div className="filter-item">
            <FormControl className="selects">
              <InputLabel id="demo-simple-select-label">
                Select Sports
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={selectedSport}
                label="Age"
                onChange={(e) => handleSportChange(e.target.value)}
              >
                {sports?.map((sport) => {
                  return (
                    <MenuItem value={sport.sportName}>
                      {sport.sportName}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </div>
          <div className="filter-item">
            <FormControl className="selects">
              <InputLabel id="demo-simple-select-label">Bet Status</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={selectedStatus}
                label="Age"
                onChange={(e) => handleStatusChange(e.target.value)}
              >
                {betStatus?.map((status) => {
                  return <MenuItem value={status}>{status}</MenuItem>;
                })}
              </Select>
            </FormControl>
          </div>
        </div>
        {dateValidationFail ? (
          <div className="validation-section">
            *From Date can not be greater than To Date
          </div>
        ) : (
          <></>
        )}
      </div>

      <div className="content-bets-ctn">
        <TableContainer sx={{ maxHeight: 540 }}>
          <Table stickyHeader className="table">
            <TableHead className="head">
              <TableRow>
                <TableCell className="web-view">Bet Time</TableCell>
                <TableCell className="web-view">Sport</TableCell>
                <TableCell>Match</TableCell>
                {/* <TableCell>Market</TableCell> */}
                <TableCell className="web-view">Market / Runner</TableCell>
                <TableCell>Odds</TableCell>
                {/* <TableCell>Bet Type</TableCell> */}
                <TableCell>Stake</TableCell>
                <TableCell className="web-view">Currency</TableCell>

                <TableCell>Bet Status</TableCell>
                <TableCell className="web-view">Result</TableCell>
                <TableCell>Returns</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredBetList
                ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                ?.map((row: BetList) => (
                  <TableRow
                    className={
                      row.betType === "BACK"
                        ? "back-bet open-bets-table-row"
                        : "lay-bet open-bets-table-row"
                    }
                  >
                    <TableCell className="web-view">
                      {moment(row.requestTime).format("DD/MM/YY hh:mm A")}
                    </TableCell>
                    <TableCell className="web-view">{row.sportName}</TableCell>
                    <TableCell className="web-view">
                      <div className="match-details">
                        <div className="desc">{row.eventName}</div>
                        <div className="desc">
                          {moment(row.requestTime).format("DD/MM/YY hh:mm A")}
                        </div>
                      </div>
                    </TableCell>
                    {/* <TableCell>{row.marketName}</TableCell> */}
                    <TableCell>
                      <div className="web-view">
                        {" "}
                        {row.marketName} / {row.runnerName}
                      </div>
                      <div className="match-details mob-view">
                        <div className="desc">
                          <b>
                            {" "}
                            {row.marketName} / {row.runnerName}
                          </b>
                        </div>
                        <div className="desc">{row.eventName}</div>
                        <div className="desc">
                          {moment(row.requestTime).format("DD/MM/YY hh:mm A")}
                        </div>
                      </div>
                    </TableCell>
                    {/* <TableCell>{row.betType}</TableCell> */}
                    <TableCell>
                      {row.marketType === "FANCY"
                        ? Number(row.sessionOutcome).toFixed(0)
                        : row.oddValue.toFixed(2)}
                    </TableCell>

                    <TableCell>
                      {/* {selectedProviderId === "SportRadar"
                      ? row.stakeAmount * 10
                      : row.stakeAmount} */}
                      <div className="web-view">{row.stakeAmount}</div>

                      <div className="match-details mob-view">
                        <div className="desc">
                          {row.stakeAmount.toFixed(2)}{" "}
                        </div>
                        <div className="desc">{row?.currency}</div>
                      </div>
                    </TableCell>
                    <TableCell className="web-view">{row?.currency}</TableCell>
                    <TableCell>{row.betStatus}</TableCell>
                    <TableCell className="web-view">
                      {row.betResult ? row.betResult : "-"}
                    </TableCell>
                    <TableCell>
                      <span
                        className={
                          Number(row.betReturns) > 0
                            ? "success b-text"
                            : "danger b-text"
                        }
                      >
                        {/* {selectedProviderId === "SportRadar"
                        ? row.betReturns * 10
                        : row.stakeAmount} */}
                        {row.betReturns}
                      </span>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 20, 30]}
          component="div"
          count={filteredBetList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    selectedProviderId: state.auth.providerId,
  };
};

export default connect(mapStateToProps, null)(BetListPage);
